import styled from 'styled-components';

export const ImageBlockWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    padding: 15px;
    margin-bottom: 25px;
`;

export const AddDiscountButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 30px
`;